export const getDefaultState = () => {
    return {
        typologies: [],
        typology: {},
        search: {
            name: null,
            description: null,
        },
        validation_typology: {
            name: null,
            description: null,
        },
    }
}
export default getDefaultState()
